import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAddWeightUnitsToHistory } from '../../actions/systemOfMeasurement';
import { getCurrentSendedLeg } from '../../selectors/sended-data';

export const useSystemMeasure = (legID, weightUnits, onWeightUnitsChange) => {
    const { convertedTo } = useSelector(getCurrentSendedLeg);
    const [firstRender, setFirstRender] = useState(true);
    const addWeightUnitsToHistory = useAddWeightUnitsToHistory();
    const handeChangeWeightUnits = useCallback(
        (evt) => {
            if (evt.currentTarget.tagName === 'BUTTON') {
                const value = +evt.currentTarget.id.split('_')[1];
                onWeightUnitsChange(value);
            }
        },
        [addWeightUnitsToHistory, onWeightUnitsChange]
    );

    const getClassName = useCallback((value) => (value === weightUnits ? 'primary' : null), [weightUnits]);

    useEffect(() => {
        if (!firstRender) {
            addWeightUnitsToHistory({
                weightUnitsState: {
                    event: 'Toggle weight units',
                    appUnits: weightUnits,
                    legBeforeToggleIs: convertedTo,
                },
                legID,
            });
        }
        setFirstRender(false);
    }, [weightUnits]);

    return {
        getClassName,
        handeChangeWeightUnits,
    };
};
